import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from '@surfline/quiver-react';
import WindIcon from '@surfline/quiver-react/dist/icons/WindIcon';
import TideIcon from '@surfline/quiver-react/dist/icons/TideIcon';
import SurfIcon from '../SurfIcon';
import SwellIcon from '../SwellIcon';
import spotIdealConditionsPropShape from '../../propTypes/spotIdealConditions';

const idealConditionTypes = [
  {
    title: 'Swell Direction',
    type: 'swell',
    image: <SwellIcon />,
  },
  {
    title: 'Wind',
    type: 'wind',
    image: <WindIcon />,
  },
  {
    title: 'Surf Height',
    type: 'surf',
    image: <SurfIcon />,
  },
  {
    title: 'Tide',
    type: 'tide',
    image: <TideIcon />,
  },
];

const IdealConditions = ({ name, href, idealConditions, doTrackEvent }) => (
  <div className="sl-ideal-conditions">
    <h3>Ideal{name} Surf Conditions</h3>
    {idealConditionTypes.map(condition => (
      <div key={condition.type} className="sl-ideal-conditions__condition">
        {condition.image}
        <div className="sl-ideal-conditions__condition__description">
          <h5>{condition.title}</h5>
          {idealConditions.loading ? (
            <Spinner />
          ) : (
            <p>
              {idealConditions[condition.type]
                ? idealConditions[condition.type]
                : 'Not available for this spot'}
            </p>
          )}
        </div>
      </div>
    ))}
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="sl-ideal-conditions__link"
      onClick={() =>
        doTrackEvent('Clicked Link', {
          linkUrl: href,
          linkName: 'view more surf and travel info',
          linkLocation: 'ideal spot conditions',
          category: 'cams & reports',
        })
      }
    >
      View more surf and travel info
    </a>
  </div>
);

IdealConditions.defaultProps = {
  idealConditions: {
    loading: false,
  },
  href: null,
};

IdealConditions.propTypes = {
  name: PropTypes.string.isRequired,
  href: PropTypes.string,
  idealConditions: spotIdealConditionsPropShape,
  doTrackEvent: PropTypes.func.isRequired,
};

export default IdealConditions;
